import React, { useRef } from 'react';
import { Link } from 'react-router-dom';

const EXTRA_NAV = [
  { label: 'POS', to: '/pos' },
  { label: 'Reports', to: '/reports', desktopOnly: true }
];

export default function StoreMainNav({ categories, selectedCategory, onSelectCategory, onSaleClick }) {
  const scrollerRef = useRef(null);

  const scrollBy = (delta) => {
    scrollerRef.current?.scrollBy({ left: delta, behavior: 'smooth' });
  };

  return (
    <nav
      className="border-b border-slate-200 bg-white"
      aria-label="Product categories"
    >
      <div className="relative mx-auto flex max-w-7xl items-center px-2 sm:px-4 lg:px-8">
        <button
          type="button"
          className="hidden shrink-0 rounded-lg border border-slate-200 bg-white p-2 text-slate-600 shadow-sm hover:bg-slate-50 md:block"
          onClick={() => scrollBy(-180)}
          aria-label="Scroll categories left"
        >
          ‹
        </button>
        <ul
          ref={scrollerRef}
          className="scrollbar-hide flex flex-1 gap-1 overflow-x-auto py-1.5 sm:gap-0 sm:py-0"
          style={{ WebkitOverflowScrolling: 'touch' }}
        >
          <li className="shrink-0">
            <button
              type="button"
              onClick={() => onSelectCategory('All')}
              className={`min-h-[44px] whitespace-nowrap rounded-lg px-3 py-2.5 text-[11px] font-bold uppercase tracking-wide sm:rounded-none sm:px-4 sm:py-4 sm:text-sm ${
                selectedCategory === 'All'
                  ? 'border-b-4 border-[#8cc63f] text-[#5c2d91]'
                  : 'border-b-4 border-transparent text-slate-600 hover:text-[#5c2d91]'
              }`}
            >
              Home
            </button>
          </li>
          <li className="shrink-0">
            <button
              type="button"
              onClick={onSaleClick}
              className="min-h-[44px] whitespace-nowrap rounded-lg px-3 py-2.5 text-[11px] font-bold uppercase tracking-wide text-red-600 hover:text-red-700 sm:rounded-none sm:px-4 sm:py-4 sm:text-sm"
            >
              Featured deals
            </button>
          </li>
          {categories
            .filter((c) => c !== 'All')
            .map((cat) => (
              <li key={cat} className="shrink-0">
                <button
                  type="button"
                  onClick={() => onSelectCategory(cat)}
                  className={`flex min-h-[44px] items-center gap-1 whitespace-nowrap rounded-lg px-3 py-2.5 text-left text-[11px] font-bold uppercase tracking-wide sm:rounded-none sm:px-4 sm:py-4 sm:text-sm ${
                    selectedCategory === cat
                      ? 'border-b-4 border-[#8cc63f] text-[#5c2d91]'
                      : 'border-b-4 border-transparent text-slate-600 hover:text-[#5c2d91]'
                  }`}
                >
                  {cat}
                  <span className="text-[10px] font-normal text-slate-400" aria-hidden>
                    ▾
                  </span>
                </button>
              </li>
            ))}
          {EXTRA_NAV.map((item) => (
            <li key={item.to} className={`shrink-0 ${item.desktopOnly ? 'hidden lg:block' : ''}`}>
              <Link
                to={item.to}
                className="block min-h-[44px] whitespace-nowrap rounded-lg px-3 py-2.5 text-[11px] font-bold uppercase tracking-wide text-slate-600 hover:bg-slate-50 hover:text-[#5c2d91] sm:rounded-none sm:px-4 sm:py-4 sm:text-sm"
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
        <button
          type="button"
          className="hidden shrink-0 rounded-lg border border-slate-200 bg-white p-2 text-slate-600 shadow-sm hover:bg-slate-50 md:block"
          onClick={() => scrollBy(180)}
          aria-label="Scroll categories right"
        >
          ›
        </button>
      </div>
    </nav>
  );
}
